import { Button, Form, Offcanvas } from "react-bootstrap";
import { useState } from "react";
import { userServices } from "../../APIServices/userServices";

const AddNewUser = ({ Show, Hide, Title, getUsers }) => {
  const [loader, setLoader] = useState(false);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  const userRegistration = async () => {
    setLoader(true);
    const userData = {
      name,
      email,
    };
    const data = await userServices.userRegistration(userData);
    if (data?.statusCode === 200) {
      setName("");
      setEmail("");
      getUsers();
      Hide();
    }
    setLoader(false);
  };

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton className="bg-light p-3 border-bottom">
        <Offcanvas.Title className="fw-bold" style={{ fontSize: 15 }}>
          {Title}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
            Name
          </Form.Label>
          <Form.Control
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter Name"
            style={{ fontSize: 12 }}
          />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
            Email
          </Form.Label>
          <Form.Control
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter Email"
            style={{ fontSize: 12 }}
          />
        </Form.Group>
      </Offcanvas.Body>
      <div className="text-end p-2 border-top bg-light">
        <Button
          disabled={!name || !email || loader}
          onClick={userRegistration}
          variant="outline-primary"
          style={{ fontSize: 13 }}
          className="rounded-2 py-1 px-3"
        >
          {loader ? "Saving..." : Title}
        </Button>
      </div>
    </Offcanvas>
  );
};

export default AddNewUser;